<section class="content">
  <div class="hgx-page">
    <div class="hgx-page-header">
      <div>
        <h1>Documents</h1>
        <p>États, reçus et fichiers générés par l’application</p>
      </div>
    </div>

    <div class="hgx-panel">
      <div class="hgx-tab-body">
        <div class="hgx-list">
          <form class="hgx-filters" (ngSubmit)="currentPage = 0; getItems()">
            <label class="hgx-field hgx-field--grow">
              <span>Rechercher</span>
              <input type="search" class="form-control" name="searchKey" placeholder="Nom ou référence du document"
                [(ngModel)]="searchKey">
            </label>
            <span class="hgx-push-right hgx-muted ged-total">{{ totalItems || 0 }} document(s)</span>
          </form>

          <div class="qh-table-wrap">
            <table class="qh-table">
              <thead>
                <tr>
                  <th class="qh-first">
                    <span class="qh-th-refresh">
                      Document
                      <button type="button" class="qh-icon-btn qh-icon-btn--sm" (click)="getItems()"
                        aria-label="Actualiser la liste" title="Actualiser">
                        <i class="material-icons-outlined" [class.qh-spin]="loading" aria-hidden="true">refresh</i>
                      </button>
                    </span>
                  </th>
                  <th>Référence</th>
                  <th>Créé par</th>
                  <th>Date</th>
                  <th class="qh-last"><span class="visually-hidden">Fichiers</span></th>
                </tr>
              </thead>
              <tbody>
                @if (loading) {
                  @for (i of [1, 2, 3, 4, 5]; track i) {
                  <tr>
                    <td colspan="5" class="placeholder-glow qh-first"><span class="placeholder col-12"></span></td>
                  </tr>
                  }
                } @else {
                  @for (item of items; track item.id) {
                  <tr>
                    <td class="qh-first qh-wrap">
                      <span class="qh-strong">{{ item.libelle }}</span>
                      @if (item.hotel_libelle) {
                      <span class="qh-sub">{{ item.hotel_libelle }}</span>
                      }
                    </td>
                    <td class="ged-ref">{{ item.codification || '—' }}</td>
                    <td>{{ item.created_by_login || '—' }}</td>
                    <td>
                      {{ item.created_at | date: 'dd/MM/yyyy' }}
                      <span class="qh-sub">{{ item.created_at | date: 'HH:mm' }}</span>
                    </td>
                    <td class="qh-last">
                      <div class="qh-row-actions">
                        @if (item.pdf_url) {
                        <button type="button" class="qh-icon-btn qh-icon-btn--bordered" (click)="openPdf(item.pdf_url)"
                          title="Aperçu du PDF" [attr.aria-label]="'Aperçu du PDF : ' + item.libelle">
                          <i class="material-icons-outlined" aria-hidden="true">visibility</i>
                        </button>
                        <a class="qh-icon-btn qh-icon-btn--bordered" [href]="item.pdf_url" download target="_blank"
                          title="Télécharger le PDF" [attr.aria-label]="'Télécharger le PDF : ' + item.libelle">
                          <i class="material-icons-outlined ged-pdf" aria-hidden="true">picture_as_pdf</i>
                        </a>
                        }
                        @if (item.excel_url) {
                        <a class="qh-icon-btn qh-icon-btn--bordered" [href]="item.excel_url" download target="_blank"
                          title="Télécharger l’Excel" [attr.aria-label]="'Télécharger l’Excel : ' + item.libelle">
                          <i class="material-icons-outlined ged-excel" aria-hidden="true">table_view</i>
                        </a>
                        }
                        @if (item.image_url) {
                        <a class="qh-icon-btn qh-icon-btn--bordered" [href]="item.image_url" target="_blank"
                          title="Voir l’image" [attr.aria-label]="'Voir l’image : ' + item.libelle">
                          <i class="material-icons-outlined" aria-hidden="true">image</i>
                        </a>
                        }
                        @if (!item.pdf_url && !item.excel_url && !item.image_url) {
                        <span class="hgx-muted">—</span>
                        }
                      </div>
                    </td>
                  </tr>
                  }
                }
              </tbody>
            </table>

            @if (!loading && items.length === 0) {
            <div class="qh-empty">
              <i class="material-icons-outlined" aria-hidden="true">folder_open</i>
              <p>Aucun document</p>
            </div>
            }

            <mat-paginator [length]="totalItems" [pageIndex]="currentPage" [pageSize]="itemsPerPage"
              [pageSizeOptions]="[10, 25, 50, 100]" (page)="pageChanged($event)">
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
